// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'secondary', 'secondary Fallback'","fontWeight":700,"fontStyle":"normal"},"className":"__className_b362bd","variable":"__variable_b362bd"};